import { render, staticRenderFns } from "./LocationField.vue?vue&type=template&id=35372a87&scoped=true&"
import script from "./LocationField.vue?vue&type=script&lang=js&"
export * from "./LocationField.vue?vue&type=script&lang=js&"
import style0 from "./LocationField.vue?vue&type=style&index=0&id=35372a87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35372a87",
  null
  
)

export default component.exports